export default [{
        name: '首页',
        path: '/',
        icon: require('../assets/menu/shouye.png'),
        classname:'shouye',
        authority: 'Manage Edit'
    },
    {
        name: '管理',
        icon: require('../assets/menu/guanli.png'),
        classname:'guanli',
        authority: 'Manage Edit',
        children: [
            {
                name: '学校库管理',
                path: '/manage/database',
                authority: 'Manage'
            },
            {
                name: '校园号审核',
                path: '/manage/fusionaudit',
                authority: 'Manage Audit'
            },
            {
                name: '校园号管理',
                path: '/manage/studio',
                match: ['manageStudioSingle'], // 如匹配路由name也可激活<Menu:activeName>
                authority: 'Manage'
            },
            {
                name: '政务号管理',
                path: '/manage/gov',
                match: ['manageGovSingle'], // 如匹配路由name也可激活<Menu:activeName>
                authority: 'Manage'
            },
            // {
            //     name: '活动管理',
            //     path: '/manage/activity',
            //     match: ['manageActivity'], // 如匹配路由name也可激活<Menu:activeName>
            //     authority: 'Manage'
            // },
            // {
            //     name: '投稿审核',
            //     path: '/manage/contributionaudit',
            //     authority: 'Manage'
            // },
            // {
            //     name: '系统配置',
            //     path: '/manage/configuration',
            //     authority: 'Manage'
            // },


        ]
    },
    {
        name: '内容管理',
        icon: require('../assets/menu/guanli.png'),
        classname:'guanli',
        authority: 'Manage Edit',
        children: [
            {
                name: '公告管理',
                path: '/manage/announcement',

                authority: 'Manage'
            },
            {
                name: '内容审核',
                path: '/manage/contentaudit',
                authority: 'Manage'
            },
            {
                name: '专辑审核',
                path: '/manage/media',
                authority: 'Manage'
            },
            // {
            //     name: '材料收集',
            //     path: '/manage/stuff',
            //     match:['StuffContent'],
            //     authority: 'Manage'
            // },
            {
                name: '内容审核记录',
                // icon: 'ios-paper-outline',
                path: '/manage/auditrecord',
                authority: 'Manage Edit',
            },
            {
                name: '内容发布列表',
                path: '/datastatistics/publishlist',
                authority: 'Manage Edit'
            },
            {
                name: '内容发布统计',
                path: '/datastatistics/publishstatistics',
                authority: 'Manage Edit'
            }
        ]
    },
    {
        name: '配置管理',
        icon: require('../assets/menu/guanli.png'),
        classname:'guanli',
        authority: 'Manage Edit',
        children: [
            {
                name: '校园号分组',
                path: '/manage/group',
                match: ['manageGroupSingle'], // 如匹配路由name也可激活<Menu:activeName>
                authority: 'Manage'
            },
            {
                name: '校园号等级管理',
                path: '/manage/level',
                match: ['manageLevelSingle'], // 如匹配路由name也可激活<Menu:activeName>
                authority: 'Manage'
            },
            {
                name: '热度榜调整',
                path: '/manage/rank',
                authority: 'Manage'
            },
            {
                name: '专辑分类管理',
                path: '/manage/classify',
                authority: 'Manage'
            },
            {
                name: '标签管理',
                path: '/manage/tagword',
                match:['tagwordarticle'],
                authority: 'Manage'
            },
            {
                name: '水印管理',
                path: '/manage/watermark',
                authority: 'Manage'
            },
            {
                name: '广告管理',
                path: '/manage/ad',
                authority: 'Manage'
            },
            {
                name: '发稿量配置管理',
                path: '/manage/draftcount',
                authority: 'Manage'
            },
            {
                name: '校园号指数管理',
                path: '/manage/index',
                authority: 'Manage'
            },
            {
                name: '所属领域管理',
                path: '/manage/filedtype',
                match: ['managefiledtypedetail'],
                authority: 'Manage'
            },
            {
                name: '校园号荣誉榜管理',
                path: '/manage/honor',
                match: 'manageHonorSingle,manageHonorStudio',
                authority: 'Manage'
            },
        ]
    },
    {
        name: '数据统计',
        icon: require('../assets/menu/tongji.png'),
        classname:'tongji',
        authority: 'Manage Edit',
        children: [
            {
                name: '校园号数据统计',
                path: '/managedatastatistics/content',
                authority: 'Manage',
                match: 'datasummary,exponential,contentdata'
            },
            {
                name: '校园号排行统计',
                path: '/datastatistics/sort',
                authority: 'Manage Edit'
            },
            {
                name: '高校号统计列表',
                path: '/datastatistics/schoollist',
                authority: 'Manage Edit'
            },
            {
                name: '专栏号统计列表',
                path: '/datastatistics/personallist',
                authority: 'Manage Edit'
            },
            {
                name: '工作量统计',
                path: '/datastatistics/workload',
                match: 'specifcworkload,workload',
                authority: 'Manage'
            },

        ]
    },
    // {
    //     name: '渠道',
    //     icon: 'social-dropbox-outline',
    //     authority: 'Manage Edit',
    //     children: [{
    //             name: '内容接入',
    //             path: '/channel/minput',
    //             authority: 'Manage',
    //             match: 'miwechatlist,miwebsitelist'
    //         },
    //         {
    //             name: '内容接入',
    //             path: '/channel/einput',
    //             authority: 'Manage Edit',
    //             match: 'eiwechatadd,eiwebsiteadd'
    //         },
    //         {
    //             name: '内容输出',
    //             path: '/channel/eoutput',
    //             authority: 'Manage Edit',
    //             match: 'eowechatadd,eomicroblogadd'
    //         }
    //     ]
    // },
    {
        name: '操作日志',
        icon: require('../assets/menu/rizhi.png'),
        classname:'rizhi',
        authority: 'Manage Edit',
        children: [{
                name: '入驻申请操作记录',
                path: '/log/apply',
                authority: 'Manage Edit'
            },
            {
                name: '校园号管理操作记录',
                path: '/log/manage',
                authority: 'Manage Edit'
            },
            {
                name: '校园号扣分记录',
                path: '/log/score',
                authority: 'Manage Edit'
            },
            {
                name: '校园号审核操作记录',
                path: '/log/info',
                authority: 'Manage Edit'
            }
        ]
    },
    {
        name: '消息设置',
        icon: require('../assets/menu/xiaoxi.png'),
        classname:'xiaoxi',
        path: '/message',
        authority: 'Manage Edit',
    },
    {
        name: '设置',
        icon: require('../assets/menu/shezhi.png'),
        classname:'shezhi',
        authority: 'Manage Edit',
        children: [{
                name: '账号信息',
                path: '/settings/account',
                authority: 'Manage Edit'
            },
            {
                name: '账号管理',
                path: '/manage/account',
                match: ['manageAccountSingle'], // 如匹配路由name也可激活<Menu:activeName>
                authority: 'Manage'
            },
        ]
    }
]



// WEBPACK FOOTER //
// ./src/config/menu.js